import { AppEnvironmentService } from '@packages/shared/core/common/services';
import { ATTRS_SPLIT_ID } from '../entities';
import type { SpanAttribute, CustomSpan, StartSpanParams } from '../entities';
import { ObservabilitySystem } from '../interfaces';
import { ObservabilitySystemDecorator } from './ObservabilitySystemDecorator';

export class ObservabilitySystemWithSplitId extends ObservabilitySystemDecorator {
  constructor(
    private readonly appEnvironment: AppEnvironmentService,
    observabilitySystem: ObservabilitySystem,
  ) {
    super(observabilitySystem);
  }

  getAttributes(): Record<string, SpanAttribute> {
    return {
      ...super.getAttributes(),
      [ATTRS_SPLIT_ID]: this.appEnvironment.getSplitId(),
    };
  }

  startSpan(params: StartSpanParams): CustomSpan {
    const span = super.startSpan(params);

    span.setAttributes({
      [ATTRS_SPLIT_ID]: this.appEnvironment.getSplitId(),
    });

    return span;
  }
}
